import type { Locale } from '@jira/platform__supported-locales/src/supported-locales.tsx';
import type { SiteAdminStatus } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type { User } from '@jira/platform__rest-user/src/user.tsx';
import type { RouteResourceError } from '@atlassian/react-resource-router';

export type DataBasic = {
	accountId: string | null;
	isAdmin: boolean;
	isAnonymous: boolean;
	isSiteAdmin: boolean;
	locale: Locale;
	siteAdminStatus: SiteAdminStatus;
	userFullname: string | null;
};

export type DataExtra = User | null;

export type Data = DataBasic & DataExtra;

export function isDataExtra(data: DataBasic | DataExtra): data is DataExtra {
	return data ? 'avatarUrls' in data : false;
}

export type ControllerBasic = {
	data: {
		user: DataBasic;
	};
	error: null;
	loading: false;
};

export type ControllerFull = {
	data: {
		user: Data;
	};
	error: Error | RouteResourceError | null;
	loading: boolean;
};

export type Controller = ControllerBasic | ControllerFull;
